import { render, staticRenderFns } from "./GridLink.vue?vue&type=template&id=50ffae3d"
import script from "./GridLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports